const DesignStudioSVG = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "80vh",
      zIndex:999
    }}
  >
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1080 1080"
      width="110%" // Adjusts size to fill the container
        height="110%" // Adjusts size to fill the container
    >
      <text
        className="cls-1"
        transform="translate(540 844)"
        style={{
          fontFamily: "Cinzel-Regular, Cinzel",
          fontSize: "125.13px",
          textAnchor: "middle",
          fill: "#242424", // Ensure the text is visible
        }}
      >
        <tspan x="0" y="0">
        BY ZEYNEB
        </tspan>
      </text>
    </svg>
  </div>
);

export default DesignStudioSVG;
